// extracted by mini-css-extract-plugin
export default {"profile-table":"manageIntegration_profile-table__mFArV","integrations-mobile-padding":"manageIntegration_integrations-mobile-padding__4N5Ga"};